// THIS FILE IS AUTOGENERATED
import file0 from "!!raw-loader!./doc/advanced/bitnodes.md";
import file1 from "!!raw-loader!./doc/advanced/bladeburners.md";
import file2 from "!!raw-loader!./doc/advanced/corporation/basic-gameplay-and-term.md";
import file3 from "!!raw-loader!./doc/advanced/corporation/boost-material.md";
import file4 from "!!raw-loader!./doc/advanced/corporation/demand-competition.md";
import file5 from "!!raw-loader!./doc/advanced/corporation/division-raw-production.md";
import file6 from "!!raw-loader!./doc/advanced/corporation/faq.md";
import file7 from "!!raw-loader!./doc/advanced/corporation/financial-statement.md";
import file8 from "!!raw-loader!./doc/advanced/corporation/general-advice.md";
import file9 from "!!raw-loader!./doc/advanced/corporation/industry-supply-chain.md";
import file10 from "!!raw-loader!./doc/advanced/corporation/miscellany.md";
import file11 from "!!raw-loader!./doc/advanced/corporation/office.md";
import file12 from "!!raw-loader!./doc/advanced/corporation/optimal-selling-price-market-ta2.md";
import file13 from "!!raw-loader!./doc/advanced/corporation/product.md";
import file14 from "!!raw-loader!./doc/advanced/corporation/quality.md";
import file15 from "!!raw-loader!./doc/advanced/corporation/smart-supply.md";
import file16 from "!!raw-loader!./doc/advanced/corporation/unlocks-upgrade-research.md";
import file17 from "!!raw-loader!./doc/advanced/corporation/warehouse.md";
import file18 from "!!raw-loader!./doc/advanced/corporation/wilson-analytics-advert.md";
import file19 from "!!raw-loader!./doc/advanced/corporations.md";
import file20 from "!!raw-loader!./doc/advanced/faction_list.md";
import file21 from "!!raw-loader!./doc/advanced/gang.md";
import file22 from "!!raw-loader!./doc/advanced/grafting.md";
import file23 from "!!raw-loader!./doc/advanced/hacknetservers.md";
import file24 from "!!raw-loader!./doc/advanced/intelligence.md";
import file25 from "!!raw-loader!./doc/advanced/offlineandbonustime.md";
import file26 from "!!raw-loader!./doc/advanced/sleeves.md";
import file27 from "!!raw-loader!./doc/advanced/sourcefiles.md";
import file28 from "!!raw-loader!./doc/advanced/stanek.md";
import file29 from "!!raw-loader!./doc/basic/augmentations.md";
import file30 from "!!raw-loader!./doc/basic/codingcontracts.md";
import file31 from "!!raw-loader!./doc/basic/companies.md";
import file32 from "!!raw-loader!./doc/basic/crimes.md";
import file33 from "!!raw-loader!./doc/basic/factions.md";
import file34 from "!!raw-loader!./doc/basic/hacking.md";
import file35 from "!!raw-loader!./doc/basic/hacknet_nodes.md";
import file36 from "!!raw-loader!./doc/basic/infiltration.md";
import file37 from "!!raw-loader!./doc/basic/programs.md";
import file38 from "!!raw-loader!./doc/basic/ram.md";
import file39 from "!!raw-loader!./doc/basic/reputation.md";
import file40 from "!!raw-loader!./doc/basic/scripts.md";
import file41 from "!!raw-loader!./doc/basic/servers.md";
import file42 from "!!raw-loader!./doc/basic/stats.md";
import file43 from "!!raw-loader!./doc/basic/stockmarket.md";
import file44 from "!!raw-loader!./doc/basic/terminal.md";
import file45 from "!!raw-loader!./doc/basic/world.md";
import file46 from "!!raw-loader!./doc/changelog-v0.md";
import file47 from "!!raw-loader!./doc/changelog-v1.md";
import file48 from "!!raw-loader!./doc/changelog.md";
import file49 from "!!raw-loader!./doc/help/bitnode_order.md";
import file50 from "!!raw-loader!./doc/help/getting_started.md";
import file51 from "!!raw-loader!./doc/help/tools_and_resources.md";
import file52 from "!!raw-loader!./doc/index.md";
import file53 from "!!raw-loader!./doc/migrations/ns2.md";
import file54 from "!!raw-loader!./doc/migrations/v1.md";
import file55 from "!!raw-loader!./doc/migrations/v2.md";
import file56 from "!!raw-loader!./doc/programming/game_frozen.md";
import file57 from "!!raw-loader!./doc/programming/go_algorithms.md";
import file58 from "!!raw-loader!./doc/programming/hackingalgorithms.md";
import file59 from "!!raw-loader!./doc/programming/learn.md";
import file60 from "!!raw-loader!./doc/programming/remote_api.md";

interface Document {
  default: string;
}
export const AllPages: Record<string, Document> = {};
AllPages["advanced/bitnodes.md"] = file0;
AllPages["advanced/bladeburners.md"] = file1;
AllPages["advanced/corporation/basic-gameplay-and-term.md"] = file2;
AllPages["advanced/corporation/boost-material.md"] = file3;
AllPages["advanced/corporation/demand-competition.md"] = file4;
AllPages["advanced/corporation/division-raw-production.md"] = file5;
AllPages["advanced/corporation/faq.md"] = file6;
AllPages["advanced/corporation/financial-statement.md"] = file7;
AllPages["advanced/corporation/general-advice.md"] = file8;
AllPages["advanced/corporation/industry-supply-chain.md"] = file9;
AllPages["advanced/corporation/miscellany.md"] = file10;
AllPages["advanced/corporation/office.md"] = file11;
AllPages["advanced/corporation/optimal-selling-price-market-ta2.md"] = file12;
AllPages["advanced/corporation/product.md"] = file13;
AllPages["advanced/corporation/quality.md"] = file14;
AllPages["advanced/corporation/smart-supply.md"] = file15;
AllPages["advanced/corporation/unlocks-upgrade-research.md"] = file16;
AllPages["advanced/corporation/warehouse.md"] = file17;
AllPages["advanced/corporation/wilson-analytics-advert.md"] = file18;
AllPages["advanced/corporations.md"] = file19;
AllPages["advanced/faction_list.md"] = file20;
AllPages["advanced/gang.md"] = file21;
AllPages["advanced/grafting.md"] = file22;
AllPages["advanced/hacknetservers.md"] = file23;
AllPages["advanced/intelligence.md"] = file24;
AllPages["advanced/offlineandbonustime.md"] = file25;
AllPages["advanced/sleeves.md"] = file26;
AllPages["advanced/sourcefiles.md"] = file27;
AllPages["advanced/stanek.md"] = file28;
AllPages["basic/augmentations.md"] = file29;
AllPages["basic/codingcontracts.md"] = file30;
AllPages["basic/companies.md"] = file31;
AllPages["basic/crimes.md"] = file32;
AllPages["basic/factions.md"] = file33;
AllPages["basic/hacking.md"] = file34;
AllPages["basic/hacknet_nodes.md"] = file35;
AllPages["basic/infiltration.md"] = file36;
AllPages["basic/programs.md"] = file37;
AllPages["basic/ram.md"] = file38;
AllPages["basic/reputation.md"] = file39;
AllPages["basic/scripts.md"] = file40;
AllPages["basic/servers.md"] = file41;
AllPages["basic/stats.md"] = file42;
AllPages["basic/stockmarket.md"] = file43;
AllPages["basic/terminal.md"] = file44;
AllPages["basic/world.md"] = file45;
AllPages["changelog-v0.md"] = file46;
AllPages["changelog-v1.md"] = file47;
AllPages["changelog.md"] = file48;
AllPages["help/bitnode_order.md"] = file49;
AllPages["help/getting_started.md"] = file50;
AllPages["help/tools_and_resources.md"] = file51;
AllPages["index.md"] = file52;
AllPages["migrations/ns2.md"] = file53;
AllPages["migrations/v1.md"] = file54;
AllPages["migrations/v2.md"] = file55;
AllPages["programming/game_frozen.md"] = file56;
AllPages["programming/go_algorithms.md"] = file57;
AllPages["programming/hackingalgorithms.md"] = file58;
AllPages["programming/learn.md"] = file59;
AllPages["programming/remote_api.md"] = file60;
